import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ICompanyFormState } from '../states/company-form.state';
import { classifyCompanyYear, CompanyYearClassification } from '../../utilities/company-activity';
import { Helpers } from '../../utilities/helpers';

export const selectCompanyFormState = createFeatureSelector<ICompanyFormState>('companyForm');

export const selectActiveCompanyId = createSelector(
    selectCompanyFormState,
    (state: ICompanyFormState) => state.companyId
);

export const selectTabYear = (tabId: string) => createSelector(
    selectCompanyFormState,
    (state: ICompanyFormState) => state.tabs[tabId]?.year ?? null
);

export const selectCompanyCode = createSelector(
    selectCompanyFormState,
    (state: ICompanyFormState) => state.companyCode
);

export const selectCompanyName = createSelector(
    selectCompanyFormState,
    (state: ICompanyFormState) => state.companyName
);

export const selectCompanyCountry = createSelector(
    selectCompanyFormState,
    (state: ICompanyFormState) => state.companyCountry
);

export const selectDefaultYear = createSelector(
    selectCompanyFormState,
    (state: ICompanyFormState) => state.defaultYear
);

export const selectInactivePeriods = createSelector(
    selectCompanyFormState,
    (state: ICompanyFormState) => state.inactivePeriods
);

export const selectInactivePeriodsLoaded = createSelector(
    selectCompanyFormState,
    (state: ICompanyFormState) => state.inactivePeriodsLoaded
);

const INACTIVE_DEFAULT: CompanyYearClassification = { status: 'active', firstActiveYear: null };

export const selectInactivityStatusForTab = (tabId: string) => createSelector(
    selectTabYear(tabId),
    selectInactivePeriods,
    selectInactivePeriodsLoaded,
    (year, periods, loaded): CompanyYearClassification => {
        if (!loaded || !year) return INACTIVE_DEFAULT;
        const parsed = Number(year);
        if (Number.isNaN(parsed)) return INACTIVE_DEFAULT;
        // Anchor firstActiveYear at the system's earliest measurement so an interior
        // gap (e.g., a single 2017 inactive year on a company active 2007–2025) doesn't
        // make the algorithm think the company started in 2018.
        const measurements = Helpers.measurements();
        const earliestSystemYear = measurements.length > 0
            ? Number(measurements[measurements.length - 1])
            : undefined;
        return classifyCompanyYear(parsed, periods, earliestSystemYear);
    }
);
